module.exports = __webpack_public_path__ + "img/18order.5cb83c3a.png";